import { NativeStackScreenProps } from '@react-navigation/native-stack';
import React from 'react';

import HelpModal from '../Components/Modals/HelpModal';
import { RootStackParamList } from '../navigator';

type Props = NativeStackScreenProps<RootStackParamList, 'Help'>;

const HelpScreen: React.FC<Props> = ({ navigation }) => {
	return <HelpModal onClose={() => navigation.goBack()} />;
};

export default HelpScreen;
